import { Component, computed, effect, inject, Injector, OnInit, runInInjectionContext } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StaticNavigationItems } from '@views/common/models/navigation-roaster.model';
import { Image } from '@vueling-ng/vy-ds/src/lib/utils';
import { LanguageService } from 'app/services/internal/language/language.service';
import { NavigationItems } from 'app/shared/models/navigation-item.model';
import { StateManagerService } from 'app/shared/state/state-manager.service';
import { environment } from 'environments/environment';
import { FeaturedCard } from '../booking-detail/models/booking-details.model';
import { HomeService } from './services/home.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {
  private readonly _translateService = inject(TranslateService);
  private readonly _stateManagerService = inject(StateManagerService);
  private readonly _homeService = inject(HomeService);
  private readonly _languageService = inject(LanguageService);
  private readonly _injector = inject(Injector);

  public readonly state = this._stateManagerService._currentState;
  public readonly currentLang = this._languageService.currentLanguage;
  public overLayBlur = false;

  public upperCards = computed(() => this.buildUpperCards(this.currentLang()));
  public lowerCards = computed(() => {
    this.currentLang();
    return this.buildLowerCards();
  });

  public ngOnInit(): void {
    this.reloadStaticsListener();
  }

  public updateBlurEvent(event: boolean): void {
    this.overLayBlur = event;
  }

  public getImageLayout(imageUrl: string): Image {
    return {
      src: imageUrl,
      alt: ''
    };
  }

  private buildUpperCards(language: string): FeaturedCard[] {
    return [
      StaticNavigationItems.bookings,
      StaticNavigationItems.invoices,
      {
        ...StaticNavigationItems.groups,
        postActionRedirectUrl: `${environment.groupsBaseUrl}${language}/GroupSearch`
      }
    ];
  }

  private buildLowerCards(): FeaturedCard[] {
    return [
      StaticNavigationItems.agency_credit,
      {
        ...StaticNavigationItems.cac,
        postActionRedirectUrl: this._translateService.instant(NavigationItems.Cac.url!) as string
      }
    ];
  }

  private reloadStaticsListener(): void {
    runInInjectionContext(this._injector, () => {
      effect(() => {
        if (this.currentLang()) {
          this._homeService.reloadStatics(this.currentLang());
        }
      });
    });
  }
}
